import type { RouteObject } from "react-router-dom";
import { PagesOemComplianceCenterUiDisplay } from "./Display";

/**
 * One route, no children. The page hosts a web component that holds its own view state inside
 * its own shadow root, so there is no `<Outlet />` for a child route to render into and no
 * DealerCenter URL segment the element would recognise.
 */
export const PagesOemComplianceCenterUiRoutes: RouteObject[] = [
  {
    path: "oemComplianceCenter",
    element: <PagesOemComplianceCenterUiDisplay />
  }
];
